// src/services/licenseService.ts
import {
  login,
  getKey,
  setLicenseCredentials,
  updatekey,
} from '../hooks/license';

export const ensureLoginFromEnv = async () => {
  const email = process.env.REACT_APP_LICENSE_EMAIL;
  const senha = process.env.REACT_APP_PASSWORD; // use PASSWORD, não "PASS"
  if (!email || !senha) throw new Error('Credenciais não configuradas (.env)');

  // coloca em memória para refresh automático
  setLicenseCredentials(email, senha);

  // realiza o primeiro login para obter o token
  return login({ email, senha });
};

export const getKeyByParams = (chave: string | number) => getKey(chave);
export const putKey = (body: Record<string, any>) => updatekey(body);
